import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import VideoType from "../../../../../detail/src/Pages/DetailPage/VideoType";
import GalleryCardComponent from "../../../../../app/src/Components/common/GalleryCardComponent";
import ContentCardComponent from "../../ContentCardComponent";
import { IMAGE_HEIGHT, IMAGE_HEIGHT_MOBILE, IMAGE_WIDTH, IMAGE_WIDTH_MOBILE } from "../../../../CatalogueConstants";
import defaultBanner from "../../../../../app/src/Resources/Images/default_banner.png";
import {getDefaultDetailBaseURL, renderImageBannerData, generateSlug} from "../../../../../app/src/Utils/utils";
import { hasContentChildren, hasNoContentChildren } from "../utils/utils";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../../../app/src/Resources/Multitenant/tenantConstants";
import ContentCardComponentV2 from "../../ContentCardComponentV2";

const ContentComponent = ({
  contents,
  changeShowNoContent,
  showNoContent,
  category,
}) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 480;

  useEffect(() => {
    if (showNoContent) {
      changeShowNoContent();
    }
  }, [showNoContent, changeShowNoContent]);

  return contents?.map((content) => (
        <>
      {hasContentChildren(content) ||  hasNoContentChildren(content) && (
      <div className="ContentContainer">
        {hasContentChildren(content) && (
          <>
            {showNoContent && changeShowNoContent()}
            <div className="PlaylistItemContainer VideoContainer">
              <Link
                  to={{
                    pathname: getDefaultDetailBaseURL() + "/" + content?.id + (content?.title ? "/" + generateSlug(content.title) : ""),
                  }}
              >
                <GalleryCardComponent
                  image={renderImageBannerData(content)}
                  width={isMobile ? IMAGE_WIDTH_MOBILE : IMAGE_WIDTH}
                  height={isMobile ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT}
                />
              </Link>
              <div className="contentFooter">
                <div className="PlaylistItemTitle-Default">{content?.title}</div>
                <VideoType subtitle={content}/>
                <div className="PlayFavContainer">
                  <div className="boton-play">
                    <Link
                        className="BotonVer button-focused"
                        to={{
                          pathname: getDefaultDetailBaseURL() + "/" + content?.id + (content?.title ? "/" + generateSlug(content.title) : ""),
                        }}
                    >
                      {t("ficha.seeDetail")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {hasNoContentChildren(content) && (
          <>
            {MULTITENANT_CONSTANTS[TENANT].discoverContentsVersion === 2 ? (
                  <ContentCardComponentV2
                      content={content}
                      defaultBanner={defaultBanner}
                      imageCard={renderImageBannerData(content)}
                      category={category} />
            ) : (
              <ContentCardComponent
                content={content}
                defaultBanner={defaultBanner}
                imageCard={renderImageBannerData(content)} />
            )}
          </>
        )}
      </div>)}
    </>
  ));
 };

export default ContentComponent;
